import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const FONTS_URL =
  "https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap";

function useFonts() {
  useEffect(() => {
    if (document.querySelector('link[href*="Instrument+Serif"]')) return;
    const l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = FONTS_URL;
    document.head.appendChild(l);
  }, []);
}

const T = {
  g700: "#155c36", g600: "#1b7a47", g500: "#1e9254", g400: "#28b566",
  g200: "#a7d9bc", g100: "#d6f0e3", g50: "#eef8f3",
  n900: "#0f1117", n800: "#1c2130", n700: "#2d3549", n600: "#4a5268",
  n400: "#8a93a8", n300: "#b0b8cc", n200: "#d1d5e0", n150: "#e4e7ef",
  n100: "#eef0f5", n50: "#f7f8fa", white: "#ffffff",
  amber: "#d97706",
  serif: "'Instrument Serif', Georgia, serif",
  sans: "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
};

const Icon = ({ name, size = 20, color = "currentColor", strokeWidth = 1.6 }) => {
  const paths = {
    ArrowLeft:    <><path d="M19 12H5"/><path d="m12 19-7-7 7-7"/></>,
    ArrowRight:   <><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></>,
    Search:       <><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></>,
    MapPin:       <><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z"/><circle cx="12" cy="10" r="3"/></>,
    Star:         <><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></>,
    Shield:       <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></>,
    Award:        <><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/></>,
    Search2:      <><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></>,
    Calendar:     <><rect width="18" height="18" x="3" y="4" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></>,
    Lock:         <><rect width="18" height="11" x="3" y="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></>,
    MessageCircle:<><path d="m3 21 1.9-5.7a8.5 8.5 0 1 1 3.8 3.8z"/></>,
    Truck:        <><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></>,
    Building:     <><rect width="16" height="20" x="4" y="2" rx="2"/><path d="M9 22v-4h6v4"/><path d="M8 6h.01M16 6h.01M12 6h.01M12 10h.01M8 10h.01M16 10h.01M8 14h.01M16 14h.01M12 14h.01"/></>,
    Box:          <><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4a2 2 0 0 0 1-1.73z"/><path d="m3.3 7 8.7 5 8.7-5"/><path d="M12 22V12"/></>,
    Sofa:         <><path d="M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3"/><path d="M2 11v5a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v2H6v-2a2 2 0 0 0-4 0Z"/><path d="M4 18v2M20 18v2"/></>,
    Users:        <><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></>,
    Warehouse:    <><path d="M22 8.35V20a1 1 0 0 1-1 1h-3.5a1 1 0 0 1-1-1v-4.5a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1V20a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8.35a1 1 0 0 1 .53-.88l9-4.78a1 1 0 0 1 .94 0l9 4.78a1 1 0 0 1 .53.88Z"/><path d="M6 18h3"/><path d="M15 18h3"/></>,
    ChevronDown:  <><path d="m6 9 6 6 6-6"/></>,
    ChevronUp:    <><path d="m18 15-6-6-6 6"/></>,
    Briefcase:    <><rect width="20" height="14" x="2" y="7" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></>,
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
      {paths[name]}
    </svg>
  );
};

/* ── Avatar ── */
function Avatar({ name, size = 42 }) {
  const initials = name.split(" ").map(w => w[0]).slice(0, 2).join("");
  const colors = [
    { bg: T.g50, text: T.g700, border: T.g100 },
    { bg: "#eff6ff", text: "#1d4ed8", border: "#bfdbfe" },
    { bg: "#fff7ed", text: "#c2410c", border: "#fed7aa" },
  ];
  const color = colors[name.charCodeAt(0) % colors.length];
  return (
    <div style={{ width: size, height: size, borderRadius: "50%", flexShrink: 0, background: color.bg, border: `1.5px solid ${color.border}`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: size * 0.35, fontWeight: 600, color: color.text, fontFamily: T.sans }}>
      {initials}
    </div>
  );
}

function Stars({ rating, size = 13 }) {
  return (
    <div style={{ display: "inline-flex", gap: 2 }}>
      {[1, 2, 3, 4, 5].map(i => (
        <svg key={i} width={size} height={size} viewBox="0 0 24 24" fill={i <= rating ? T.amber : T.n150} stroke="none">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
        </svg>
      ))}
    </div>
  );
}

/* ── Location search bar ── */
function LocationSearchBar() {
  const navigate = useNavigate();
  const [location, setLocation] = useState("");

  const handleSearch = () => {
    const params = new URLSearchParams({ category: "moving" });
    if (location.trim()) params.set("location", location.trim());
    navigate(`/search?${params.toString()}`);
  };

  return (
    <div style={{ display: "flex", gap: 10, maxWidth: 520, flexWrap: "wrap" }}>
      <div style={{ position: "relative", flex: "1 1 260px" }}>
        <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}>
          <Icon name="MapPin" size={16} color={T.n400} strokeWidth={2} />
        </span>
        <input
          type="text"
          value={location}
          onChange={e => setLocation(e.target.value)}
          onKeyDown={e => e.key === "Enter" && handleSearch()}
          placeholder="Enter your area or estate"
          style={{
            width: "100%", padding: "14px 14px 14px 42px",
            border: `1.5px solid ${T.n150}`, borderRadius: 12,
            fontSize: 14, fontFamily: T.sans, color: T.n900,
            background: T.white, outline: "none", boxSizing: "border-box",
          }}
          onFocus={e => (e.target.style.borderColor = T.g500)}
          onBlur={e => (e.target.style.borderColor = T.n150)}
        />
      </div>
      <button onClick={handleSearch} style={{
        display: "inline-flex", alignItems: "center", gap: 8,
        padding: "14px 24px", background: T.g500, color: T.white,
        border: "none", borderRadius: 12, fontSize: 14, fontWeight: 600,
        fontFamily: T.sans, cursor: "pointer", letterSpacing: "0.01em",
      }}
      onMouseEnter={e => (e.currentTarget.style.background = T.g600)}
      onMouseLeave={e => (e.currentTarget.style.background = T.g500)}>
        <Icon name="Search" size={16} color={T.white} strokeWidth={2} />
        Find a moving team
      </button>
    </div>
  );
}

/* ── Sub-service card ── */
const SUB_SERVICES = [
  { icon: "Truck",      name: "House moving (full home)",   price: "KES 8,000 – 45,000",  unit: "per move",  desc: "Full household relocation including loading, transport, and offloading at your new home." },
  { icon: "Building",   name: "Office relocation",          price: "KES 15,000 – 80,000", unit: "per move",  desc: "Planned office moves including furniture, equipment, and documents, with minimal downtime." },
  { icon: "Box",        name: "Packing & unpacking",         price: "KES 2,500 – 12,000",  unit: "per visit", desc: "Professional packing of belongings with proper materials, and unpacking at your destination." },
  { icon: "Sofa",       name: "Furniture moving (single items)", price: "KES 1,500 – 6,000", unit: "per item", desc: "Moving individual large items like sofas, beds, or appliances between locations." },
  { icon: "Users",      name: "Loading & offloading labour", price: "KES 1,000 – 4,000",  unit: "per hour",  desc: "Hands-on labour for loading or offloading a truck, with or without your own transport." },
  { icon: "Warehouse",  name: "Storage & transport",         price: "KES 3,000 – 15,000",  unit: "per month", desc: "Short and long-term storage solutions with transport arranged to and from the facility." },
];

function SubServiceCard({ s }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding: "22px", borderRadius: 16,
        border: `1.5px solid ${hovered ? T.g200 : T.n150}`,
        background: hovered ? T.g50 : T.white,
        transition: "all .15s",
      }}>
      <div style={{ width: 42, height: 42, borderRadius: 12, background: T.g50, border: `1.5px solid ${T.g100}`, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 14 }}>
        <Icon name={s.icon} size={19} color={T.g500} strokeWidth={1.6} />
      </div>
      <div style={{ fontSize: 15, fontWeight: 600, color: T.n900, marginBottom: 6 }}>{s.name}</div>
      <p style={{ fontSize: 13, color: T.n600, lineHeight: 1.65, margin: "0 0 14px" }}>{s.desc}</p>
      <div style={{ display: "flex", alignItems: "baseline", gap: 6, paddingTop: 12, borderTop: `1px solid ${T.n100}` }}>
        <span style={{ fontFamily: T.serif, fontSize: 17, fontWeight: 400, color: T.g700, letterSpacing: "-0.01em" }}>{s.price}</span>
        <span style={{ fontSize: 12, color: T.n400 }}>{s.unit}</span>
      </div>
    </div>
  );
}

/* ── How it works step ── */
function HowStep({ num, icon, title, desc }) {
  return (
    <div style={{ display: "flex", gap: 18, padding: "22px 0", borderBottom: `1px solid ${T.n100}` }}>
      <div style={{ width: 42, height: 42, borderRadius: 12, background: T.g50, border: `1.5px solid ${T.g100}`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
        <Icon name={icon} size={18} color={T.g500} strokeWidth={1.6} />
      </div>
      <div style={{ flex: 1, paddingTop: 2 }}>
        <div style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.09em", textTransform: "uppercase", marginBottom: 5 }}>Step {num}</div>
        <div style={{ fontSize: 15, fontWeight: 600, color: T.n900, marginBottom: 5 }}>{title}</div>
        <p style={{ fontSize: 14, color: T.n600, lineHeight: 1.7, margin: 0 }}>{desc}</p>
      </div>
    </div>
  );
}

/* ── Trust row ── */
function TrustRow({ icon, title, desc }) {
  return (
    <div style={{ display: "flex", gap: 16, padding: "18px 0", borderBottom: `1px solid ${T.n100}` }}>
      <div style={{ width: 38, height: 38, borderRadius: 10, background: T.white, border: `1px solid ${T.g200}`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
        <Icon name={icon} size={16} color={T.g500} strokeWidth={1.7} />
      </div>
      <div style={{ flex: 1, paddingTop: 1 }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: T.n800, marginBottom: 3 }}>{title}</div>
        <div style={{ fontSize: 14, color: T.n600, lineHeight: 1.65 }}>{desc}</div>
      </div>
    </div>
  );
}

/* ── Testimonial ── */
function Testimonial({ name, location, rating, text }) {
  return (
    <div style={{ padding: "22px", borderRadius: 16, border: `1px solid ${T.n150}`, background: T.white, display: "flex", flexDirection: "column", gap: 12 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <Avatar name={name} />
        <div>
          <div style={{ fontSize: 14, fontWeight: 600, color: T.n900 }}>{name}</div>
          <div style={{ fontSize: 12, color: T.n400 }}>{location}</div>
        </div>
      </div>
      <Stars rating={rating} />
      <p style={{ fontSize: 14, color: T.n600, lineHeight: 1.7, margin: 0, fontStyle: "italic" }}>"{text}"</p>
    </div>
  );
}

/* ── FAQ ── */
function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ borderBottom: `1px solid ${T.n100}` }}>
      <button onClick={() => setOpen(o => !o)} style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "18px 0", background: "none", border: "none", cursor: "pointer", fontFamily: T.sans, textAlign: "left", gap: 16 }}>
        <span style={{ fontSize: 15, fontWeight: 600, color: T.n800, lineHeight: 1.4 }}>{q}</span>
        <span style={{ flexShrink: 0, color: T.n400 }}><Icon name={open ? "ChevronUp" : "ChevronDown"} size={18} strokeWidth={2} /></span>
      </button>
      {open && <p style={{ fontSize: 14, color: T.n600, lineHeight: 1.75, margin: "0 0 18px", paddingRight: 32 }}>{a}</p>}
    </div>
  );
}

/* ── Section head ── */
function SectionHead({ eyebrow, title, em, sub }) {
  return (
    <div style={{ marginBottom: 6 }}>
      <span style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", display: "block", marginBottom: 6 }}>{eyebrow}</span>
      <h2 style={{ fontFamily: T.serif, fontSize: "clamp(24px,4vw,32px)", fontWeight: 400, color: T.n900, margin: "0 0 6px", letterSpacing: "-0.03em", lineHeight: 1.2 }}>
        {title} <em style={{ fontStyle: "italic", color: T.g600 }}>{em}</em>
      </h2>
      {sub && <p style={{ fontSize: 15, color: T.n400, margin: 0, lineHeight: 1.65 }}>{sub}</p>}
    </div>
  );
}

/* ══ Main page ══ */
export default function MovingRelocationPage() {
  useFonts();
  const navigate = useNavigate();

  const faqs = [
    { q: "How is moving pricing calculated?", a: "Pricing depends on the volume of items, distance between locations, and whether packing services are included. Smaller jobs like single furniture moves or hourly labour are priced more simply, while full house or office moves are typically quoted after the team understands your inventory and locations. Always confirm the full quote before booking." },
    { q: "Do moving teams provide packing materials?", a: "Many JiraniPros offering packing services include boxes, tape, and protective wrapping as part of their service, while others may charge separately for materials. This is shown on their profile or can be confirmed directly through in-app messaging before booking." },
    { q: "Is my furniture insured during the move?", a: "Coverage varies by professional. Some JiraniPros include basic liability for damage during transport, which is stated on their profile. For high-value items, it is worth messaging the mover beforehand to clarify what is covered and consider additional precautions for fragile or valuable belongings." },
    { q: "Can I book a move for the same day or do I need advance notice?", a: "Availability depends on the moving team and your location. Many movers can accommodate next-day bookings, and some offer same-day service depending on demand. For larger moves such as full houses or offices, booking a few days ahead generally gives you more choice and better rates." },
    { q: "What happens if something is damaged during the move?", a: "If an item is damaged during a booking made through JiraniApp, raise a dispute within 48 hours through the Help and Support page with photos and details. Our Trust and Safety team reviews the claim and works with both parties toward a fair resolution under the Jirani Guarantee." },
    { q: "Do I need to be present during the entire move?", a: "It is recommended to be present at both the pickup and drop-off locations, particularly for full house or office moves, to confirm inventory and address. For smaller jobs like single item moves, some clients arrange access without being present, which can be discussed directly with the mover." },
  ];

  return (
    <div style={{ fontFamily: T.sans, background: T.white, minHeight: "100vh", color: T.n900 }}>
      <style>{`* { box-sizing: border-box; }`}</style>

      {/* ── Nav ── */}
      <div style={{ padding: "20px 24px", borderBottom: `1px solid ${T.n100}`, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
        <button onClick={() => navigate(-1)} style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "none", border: "none", cursor: "pointer", color: T.n400, fontSize: 13, fontFamily: T.sans, padding: 0 }}
          onMouseEnter={e => (e.currentTarget.style.color = T.n800)}
          onMouseLeave={e => (e.currentTarget.style.color = T.n400)}>
          <Icon name="ArrowLeft" size={14} strokeWidth={2} />
          Back
        </button>
        <button onClick={() => navigate("/pro-onboarding")} style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          background: "none", border: "none", cursor: "pointer",
          color: T.g600, fontSize: 13, fontFamily: T.sans, fontWeight: 600, padding: 0,
        }}>
          <Icon name="Briefcase" size={14} strokeWidth={2} />
          Run a moving team? Join JiraniApp
        </button>
      </div>

      {/* ── Hero ── */}
      <div style={{ padding: "clamp(48px,7vw,84px) 20px clamp(40px,5vw,56px)", borderBottom: `1px solid ${T.n100}` }}>
        <div style={{ maxWidth: 720, margin: "0 auto" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 7, color: T.g600, fontSize: 12, fontWeight: 600, letterSpacing: "0.09em", textTransform: "uppercase", marginBottom: 20 }}>
            <Icon name="Truck" size={14} color={T.g500} strokeWidth={2.2} />
            Moving & Relocation
          </div>
          <h1 style={{ fontFamily: T.serif, fontSize: "clamp(38px,7vw,60px)", fontWeight: 400, margin: "0 0 18px", lineHeight: 1.08, color: T.n900, letterSpacing: "-0.03em", maxWidth: 580 }}>
            Moving made{" "}
            <em style={{ fontStyle: "italic", color: T.g600 }}>stress-free</em>
          </h1>
          <p style={{ fontSize: "clamp(15px,2vw,17px)", color: T.n600, lineHeight: 1.75, margin: "0 0 32px", maxWidth: 520 }}>
            From a single sofa to a full house or office move, find verified moving teams
            near you with transparent pricing and real reviews from other clients.
          </p>
          <LocationSearchBar />
        </div>
      </div>

      <div style={{ maxWidth: 720, margin: "0 auto", padding: "0 20px clamp(80px,10vw,120px)" }}>

        {/* ── Sub-services grid ── */}
        <div style={{ paddingTop: "clamp(40px,6vw,56px)", marginBottom: "clamp(48px,7vw,72px)" }}>
          <SectionHead eyebrow="Services" title="What moving teams on" em="JiraniApp do" sub="Pricing varies by volume, distance, and labour required. These are typical ranges." />
          <div style={{ marginTop: 20, display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 14 }}>
            {SUB_SERVICES.map(s => <SubServiceCard key={s.name} s={s} />)}
          </div>
        </div>

        {/* ── How it works ── */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)" }}>
          <SectionHead eyebrow="How it works" title="Booking a move," em="step by step" sub="From search to settled in your new space in four simple steps." />
          <div style={{ marginTop: 8 }}>
            <HowStep num="01" icon="Search2" title="Search and compare moving teams near you" desc="Enter your area and browse verified moving professionals with ratings, vehicle details, and transparent pricing for each service type." />
            <HowStep num="02" icon="Calendar" title="Book a date and describe the move" desc="Choose a moving date and share details — pickup and drop-off locations, approximate inventory, and whether you need packing help. Larger moves can be discussed via message first." />
            <HowStep num="03" icon="Truck" title="Your moving team gets to work" desc="Track the job status in the app and stay in touch with your team throughout the move. Payment is held securely until everything is safely delivered." />
            <HowStep num="04" icon="Star" title="Rate your experience" desc="Once you are settled in, leave a rating and review. Need help with unpacking or follow-up tasks? Book the same team again directly from their profile." />
          </div>
        </div>

        {/* ── Trust section ── */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)", padding: "clamp(28px,5vw,40px)", borderRadius: 20, background: T.g50, border: `1px solid ${T.g100}` }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 7, color: T.g600, fontSize: 11, fontWeight: 600, letterSpacing: "0.09em", textTransform: "uppercase", marginBottom: 14 }}>
            <Icon name="Shield" size={13} color={T.g500} strokeWidth={2} />
            Jirani Guarantee
          </div>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(22px,3.5vw,28px)", fontWeight: 400, color: T.n900, margin: "0 0 6px", letterSpacing: "-0.03em", lineHeight: 1.2 }}>
            Every booking is <em style={{ fontStyle: "italic", color: T.g600 }}>protected</em>
          </h2>
          <p style={{ fontSize: 14, color: T.n600, margin: "0 0 8px", lineHeight: 1.65 }}>How we keep moving bookings safe and reliable.</p>
          <div style={{ marginTop: 10 }}>
            <TrustRow icon="Award" title="ID verified moving teams" desc="Every mover on JiraniApp completes identity verification before their profile goes live, so you know exactly who is handling your belongings." />
            <TrustRow icon="Star" title="Reviews from real bookings" desc="All ratings and reviews are tied to completed, verified jobs. Read what other clients say about a team's care and reliability before you book." />
            <TrustRow icon="Lock" title="Secure payment held until completion" desc="Your payment is held securely and only released to the moving team once the job is marked complete to your satisfaction." />
            <TrustRow icon="MessageCircle" title="48-hour dispute resolution" desc="If anything goes wrong during the move, raise it within 48 hours and our Trust and Safety team will review and resolve it fairly." />
          </div>
        </div>

        {/* ── Testimonials ── */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)" }}>
          <SectionHead eyebrow="Client stories" title="What clients" em="are saying" />
          <div style={{ marginTop: 20, display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 14 }}>
            <Testimonial name="Susan N." location="Kileleshwa, Nairobi" rating={5} text="The team handled my entire move from a two bedroom to a new apartment in one afternoon. Nothing was damaged and they were careful with everything." />
            <Testimonial name="Brian K." location="Westlands, Nairobi" rating={5} text="Booked office relocation for a small team of twelve. They had us packed up and operational in the new space by end of day. Very organised." />
            <Testimonial name="Asha M." location="Nyali, Mombasa" rating={4} text="Needed a single wardrobe moved across town and they handled it quickly and carefully. Communication was great throughout." />
          </div>
        </div>

        {/* ── FAQ ── */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)" }}>
          <SectionHead eyebrow="Questions" title="Common" em="questions" sub="Things clients ask before booking a move." />
          <div style={{ marginTop: 8 }}>
            {faqs.map((f, i) => <FaqItem key={i} {...f} />)}
          </div>
        </div>

        {/* ── CTA ── */}
        <div style={{ padding: "clamp(32px,5vw,48px)", borderRadius: 20, border: `1px solid ${T.n150}`, textAlign: "center", background: T.n50 }}>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 12px", letterSpacing: "-0.03em", lineHeight: 1.2 }}>
            Ready for your next{" "}
            <em style={{ fontStyle: "italic", color: T.g600 }}>move?</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 28px", lineHeight: 1.65 }}>
            Browse verified moving teams near you and book in minutes.
          </p>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
            <button onClick={() => navigate("/search?category=moving")} style={{
              padding: "13px 28px", background: T.g500, color: T.white,
              border: "none", borderRadius: 11, fontSize: 14, fontWeight: 600,
              fontFamily: T.sans, cursor: "pointer", letterSpacing: "0.01em",
              display: "inline-flex", alignItems: "center", gap: 8,
            }}
            onMouseEnter={e => (e.currentTarget.style.background = T.g600)}
            onMouseLeave={e => (e.currentTarget.style.background = T.g500)}>
              Find a moving team
              <Icon name="ArrowRight" size={15} color={T.white} strokeWidth={2} />
            </button>
            <button onClick={() => navigate("/how-it-works")} style={{
              padding: "13px 28px", background: "transparent", color: T.n700,
              border: `1.5px solid ${T.n200}`, borderRadius: 11, fontSize: 14, fontWeight: 600,
              fontFamily: T.sans, cursor: "pointer", letterSpacing: "0.01em",
            }}
            onMouseEnter={e => (e.currentTarget.style.borderColor = T.n400)}
            onMouseLeave={e => (e.currentTarget.style.borderColor = T.n200)}>
              How JiraniApp works
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}